export default __webpack_public_path__ + "static/media/decaysofnature.f1a56823.png";